import {useObservable} from 'rxjs-hooks'
import {fromEvent} from 'rxjs'
import {map} from 'rxjs/operators'

// Hook to listen to window.innerHeight change when URL bar
// appears and disappears on mobile
export function useWindowRatioHeightOverWidth(): number {
  return useObservable<number>(() => 
    fromEvent(window, 'resize').pipe(
      map(() => window.innerHeight/window.innerWidth),
    ),
    window.innerHeight/window.innerWidth
  )
}

export default useWindowRatioHeightOverWidth